import { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { ScrollArea } from "@/components/ui/scroll-area";

interface RootLayoutProps {
  children: ReactNode;
  hideFooter?: boolean;
}

export function RootLayout({ children, hideFooter = false }: RootLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
}